export default __webpack_public_path__ + "static/media/bar_chart_red.c6c5f2ac.svg";